import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const AddPackageForm = () => {
  const [formData, setFormData] = useState({
    packageName: "Vital Package",
    destination: "Kerala",
    country: "India",
    price: "100000",
    numberOfNights: "3",
    numberOfDays: "4",
    validUntil: "2025-08-31",
    description: "A good family trip",
    accommodationDetails: "3N stay at 4-star hotel",
    mealInclusions: "Breakfast, Lunch, Dinner",
    sightseeingAndTransfers: "Local tour, pickup-drop",
    exclusions: "Flight fare, personal expenses",
    priceNote: "Per person rate for 2 pax minimum",
    isInternational: "true", // default to true
    image1: null,
    image2: null,
  });

  const [previewImage, setPreviewImage] = useState({ image1: null, image2: null });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
      setPreviewImage((prev) => ({ ...prev, [name]: URL.createObjectURL(files[0]) }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      for (const key in formData) {
        if (formData[key]) {
          if (key === "isInternational") {
            data.append(key, formData[key] === "true");
          } else {
            data.append(key, formData[key]);
          }
        }
      }
  
      const res = await axios.post("http://localhost:8080/packages/add", data);
      alert("Package added successfully!");
      console.log(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to add package");
    }
  };
  

  return (
    <motion.div
      className="max-w-2xl mx-auto bg-slate-900 rounded-2xl p-6 shadow-2xl mt-10 text-slate-200"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-2xl font-bold mb-6">Add Travel Package</h2>

      <form onSubmit={handleSubmit} className="space-y-5" encType="multipart/form-data">
        <div>
          <label className="block text-sm font-medium">Package Name</label>
          <input
            type="text"
            name="packageName"
            value={formData.packageName}
            onChange={handleChange}
            className="input"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium">Destination</label>
            <input
              type="text"
              name="destination"
              value={formData.destination}
              onChange={handleChange}
              className="input"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Country</label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleChange}
              className="input"
              required
            />
          </div>
        </div>



        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium">Price</label>
            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className="input"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Valid Until</label>
            <input
              type="date"
              name="validUntil"
              value={formData.validUntil}
              onChange={handleChange}
              className="input"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium">No. of Nights</label>
            <input
              type="number"
              name="numberOfNights"
              value={formData.numberOfNights}
              onChange={handleChange}
              className="input"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium">No. of Days</label>
            <input
              type="number"
              name="numberOfDays"
              value={formData.numberOfDays}
              onChange={handleChange}
              className="input"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="input"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Accommodation Details</label>
          <textarea
            name="accommodationDetails"
            value={formData.accommodationDetails}
            onChange={handleChange}
            rows={2}
            className="input"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Meal Inclusions</label>
          <textarea
            name="mealInclusions"
            value={formData.mealInclusions}
            onChange={handleChange}
            rows={2}
            className="input"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Sightseeing and Transfers</label>
          <textarea
            name="sightseeingAndTransfers"
            value={formData.sightseeingAndTransfers}
            onChange={handleChange}
            rows={2}
            className="input"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Exclusions</label>
          <textarea
            name="exclusions"
            value={formData.exclusions}
            onChange={handleChange}
            rows={2}
            className="input"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Price Note</label>
          <textarea
            name="priceNote"
            value={formData.priceNote}
            onChange={handleChange}
            rows={2}
            className="input"
            required
          />
        </div>
        {/* ✅ International Radio Buttons */}
        <div>
          <label className="block text-sm font-medium mb-1">Is this an International Package?</label>
          <div className="flex gap-6">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="isInternational"
                value="true"
                checked={formData.isInternational === "true"}
                onChange={handleChange}
                className="mr-2"
              />
              Yes
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="isInternational"
                value="false"
                checked={formData.isInternational === "false"}
                onChange={handleChange}
                className="mr-2"
              />
              No
            </label>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium">Image 1</label>
          <input
            type="file"
            name="image1"
            accept="image/*"
            onChange={handleChange}
            className="file-input"
          />
        </div>

        {previewImage.image1 && (
          <div className="mt-2">
            <label className="block text-sm font-medium mb-1">Preview:</label>
            <img src={previewImage.image1} alt="Preview 1" className="rounded-lg w-28" />
          </div>
        )}

        <div>
          <label className="block text-sm font-medium mt-4">Image 2</label>
          <input
            type="file"
            name="image2"
            accept="image/*"
            onChange={handleChange}
            className="file-input"
          />
        </div>

        {previewImage.image2 && (
          <div className="mt-2">
            <label className="block text-sm font-medium mb-1">Preview:</label>
            <img src={previewImage.image2} alt="Preview 2" className="rounded-lg w-28" />
          </div>
        )}


        <div>
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition"
          >
            Submit
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default AddPackageForm;
